import { getMessage } from '../../components';

export default (messages) => {
    return {
        guardianFirstName: {
            identifier: 'guardianFirstName',
            required: true,
            validations: {
                maxLength: 50
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.guardian.firstName'), '50'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.guardian.firstName')
            }
        },
        guardianLastName: {
            identifier: 'guardianLastName',
            required: true,
            validations: {
                maxLength: 50
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.guardian.lastName'), '50'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.guardian.lastName')
            }
        },
        guardianEmail: {
            identifier: 'guardianEmail',
            required: true,
            validations: {
                isEmail: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isEmail: getMessage(messages, 'errors.epic.validation.email')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.guardian.email')
            }
        },
        guardianPhoneNumber: {
            identifier: 'guardianPhoneNumber',
            required: true,
            validations: {
                maxLength: 17,
                isValidPhoneNumber: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isValidPhoneNumber: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.phoneNumber')]),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.profile.guardian.phone'), '17'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.profile.guardian.phone')
            }
        }
    };
};
